import { useParams, useNavigate } from "react-router-dom";
import { fetchPackageBySlug } from "../api/packages";
import { useState, useRef, useEffect } from "react";
import PackageAvailabilityCalendar from "../components/PackageAvailabilityCalendar";
import useSEO from "../hooks/useSEO";
import PageHeader from "./PageHeader";


import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import {
  Hotel,
  Plane,
  Utensils,
  Map,
  Wifi,
  ParkingCircle,
  Dumbbell,
  Waves,
  ShieldCheck,
} from "lucide-react";


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {safeString} from "../utils/langUtils";



const AMENITY_ICON_MAP = {
  Hotel: Hotel,
  Flights: Plane,
  Meals: Utensils,
  Tours: Map,
  Wifi: Wifi,
  Parking: ParkingCircle,
  Gym: Dumbbell,
  Pool: Waves,
  Security: ShieldCheck,
};




export default function PackageDetails() {

 //=================From mongoDB Data simulation=================
const { slug } = useParams();
const navigate = useNavigate();

const [pkg, setPkg] = useState(null);
const [loading, setLoading] = useState(true);
 //From mongoDB Data simulation end

 const [bookingInfo, setBookingInfo] = useState(null); // To capture availability info


 
  const amenities = Array.isArray(pkg?.amenities) ? pkg.amenities : [];


  /* ================= IMAGES ================= */
  const galleryImages =
    pkg?.images && pkg.images.length > 0
      ? pkg.images
      : [pkg?.image || "/assets/images/holiday/default.jpg"];

  const totalPhotos = galleryImages.length;

  /* ================= LIGHTBOX STATE ================= */
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const handleOpenLightbox = (index = 0) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };

/* Images source */
const imagesForLightbox = galleryImages;
const hasImages = imagesForLightbox.length > 0;

const PLACEHOLDER = "/assets/images/holiday/default.jpg";

/* Swipe support */
const touchStartX = useRef(0);
const touchEndX = useRef(0);
const MIN_SWIPE_DISTANCE = 50;

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  touchEndX.current = e.touches[0].clientX;
};

const handleTouchEnd = () => {
  const distance = touchStartX.current - touchEndX.current;
  if (Math.abs(distance) < MIN_SWIPE_DISTANCE) return;

  if (distance > 0) {
    // swipe left → next
    setLightboxIndex((prev) =>
      prev === imagesForLightbox.length - 1 ? 0 : prev + 1
    );
  } else {
    // swipe right → prev
    setLightboxIndex((prev) =>
      prev === 0 ? imagesForLightbox.length - 1 : prev - 1
    );
  }
};


//useEffect to fetch package data from MongoDB simulation
// useEffect(() => {
//   setLoading(true);

//   fetchPackageBySlug(slug)
//     .then((data) => setPkg(data))
//     .catch((err) => {
//       console.error("Failed to load package", err);
//       setPkg(null);
//     })
//     .finally(() => setLoading(false));
// }, [slug]);


useEffect(() => {
  setLoading(true);

  fetchPackageBySlug(slug)
    .then((data) => {
      if (data) {
        const cleanPkg = {
          ...data,
          title: safeString(data.title),
          description: safeString(data.description),
          duration: safeString(data.duration),
          amenities: Array.isArray(data.amenities) 
                      ? data.amenities.map(a => safeString(a)) 
                      : [],
        };
        setPkg(cleanPkg);
      } else {
        setPkg(null);
      }
    })
    .catch((err) => {
      console.error("Failed to load package", err);
      setPkg(null);
    })
    .finally(() => setLoading(false));
}, [slug]);


//End MongoDB simulation

/* Image resolver */
const getImageUrl = (index) =>
  imagesForLightbox[index] || PLACEHOLDER;
//=================Lightbox code end=================

//===========Description Truck=================
const [showFullDescription, setShowFullDescription] = useState(false);
//=================Description Truck End=================




  /* ================= SEO (UNCHANGED) ================= */
  const title = pkg?.seo?.title || "Holiday Packages";
  const description =
    pkg?.seo?.description || "Explore our exclusive holiday packages.";
  const image = pkg?.image || "/assets/images/holiday/default.jpg";
  const url = `${window.location.origin}/packages/${slug}`;

  const packageSchema = pkg
    ? {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        name: pkg.title,
        description: pkg.description,
        image: pkg.image,
        offers: {
          "@type": "Offer",
          price: pkg.price,
          priceCurrency: "USD",
          availability: pkg.available
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
          url,
        },
      }
    : null;

  useSEO({
    title,
    description,
    image,
    url,
    schemaType: "package",
    schemaData: packageSchema,
  });

  if (!pkg) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <h1 className="text-2xl font-semibold">Package not found</h1>
      </div>
    );
  }

  //=================Auto Pragraph Her=================
//   const renderDescription = (text) => {
//   if (!text) return null;

//   // Split blocks by double line breaks
//   const blocks = text.split(/\n\s*\n/);

//   return blocks.map((block, index) => {
//     const trimmed = block.trim();

//     // Ordered list (1. 2. 3.)
//     if (/^\d+\.\s/.test(trimmed)) {
//       const items = trimmed.split(/\n/).map(i => i.replace(/^\d+\.\s*/, ""));
//       return (
//         <ol
//           key={index}
//           className="list-decimal pl-6 space-y-2 text-slate-700"
//         >
//           {items.map((item, i) => (
//             <li key={i}>{item}</li>
//           ))}
//         </ol>
//       );
//     }

//     // Unordered list (- or •)
//     if (/^[-•]\s/.test(trimmed)) {
//       const items = trimmed.split(/\n/).map(i => i.replace(/^[-•]\s*/, ""));
//       return (
//         <ul
//           key={index}
//           className="list-disc pl-6 space-y-2 text-slate-700"
//         >
//           {items.map((item, i) => (
//             <li key={i}>{item}</li>
//           ))}
//         </ul>
//       );
//     }

//     // Normal paragraph
//     return (
//       <p
//         key={index}
//         className="text-lg text-slate-700 leading-relaxed"
//       >
//         {trimmed}
//       </p>
//     );
//   });
// };

const renderDescription = (text) => {
  // Check if text exists AND is a string
  if (!text || typeof text !== 'string') {
    return null;
  }

  // Split blocks by double line breaks
  const blocks = text.split(/\n\s*\n/);

  return blocks.map((block, index) => {
    const trimmed = block.trim();
    if (!trimmed) return null; // Skip empty blocks

    // ... rest of your existing logic (Ordered list, Unordered list, Paragraph)
    if (/^\d+\.\s/.test(trimmed)) {
       // ... existing list code
    }
    // ...
    return (
      <p key={index} className="text-lg text-slate-700 leading-relaxed">
        {trimmed}
      </p>
    );
  });
};
//=================Auto Pragraph Her End=================


  return (
    <>
      {/* <PageHeader title={pkg.title} subtitle={pkg.duration} /> */}



      <main className="max-w-7xl mx-auto px-4 py-6">
            <PageHeader 
          title={safeString(pkg.title)} 
          subtitle={safeString(pkg.duration)} 
        />
        <button
          onClick={() => navigate(-1)}
          className="text-sm text-slate-500 hover:text-slate-900 mb-6"
        >

          ← Back to packages
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* ================= LEFT ================= */}
          <div className="lg:col-span-8 min-w-0">
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-6 md:p-8 space-y-6 overflow-hidden">

              {/* IMAGE GRID */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 h-[400px] md:h-[500px]">
                {/* FEATURED */}
                <button
                  type="button"
                  className="relative col-span-1 md:col-span-2 h-full group overflow-hidden rounded-xl"
                  onClick={() => handleOpenLightbox(0)}
                >
                  <img
                    src={galleryImages[0]}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    alt={`${pkg.title} featured`}
                  />
                  <span className="absolute top-4 left-4 bg-white/90 text-xs font-bold px-3 py-1.5 rounded-full">
                    FEATURED
                  </span>
                </button>

                {/* SIDE IMAGES */}
                <div className="hidden md:flex flex-col gap-2 h-full">
                  {galleryImages.slice(1, 3).map((img, idx) => (
                    <button
                      key={idx}
                      type="button"
                      onClick={() => handleOpenLightbox(idx + 1)}
                      className="relative flex-1 overflow-hidden rounded-xl"
                    >
                      <img
                        src={img}
                        className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                        alt={`view ${idx + 2}`}
                      />
                      {idx === 1 && totalPhotos > 3 && (
                        <div className="absolute inset-0 bg-black/50 flex items-center justify-center text-white font-semibold">
                          +{totalPhotos - 3} photos
                        </div>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* GALLERY FOOTER */}
              <div className="flex justify-between items-center pt-4 border-t text-sm text-slate-600">
                <span>📷 Photo gallery</span>
                <button
                  onClick={() => handleOpenLightbox(0)}
                  className="text-blue-600 font-medium hover:underline"
                >
                  {totalPhotos} photos · View all
                </button>
              </div>

              {/* CONTENT */}
              <h1 className="text-3xl font-bold">{pkg.title}</h1>
              <div className="text-yellow-400 text-sm">★★★★★</div>
              {/* <p className="text-slate-600">{pkg.duration}</p> */}
               
              
                {/* DESCRIPTION WITH AUTO FORMAT + READ MORE */}
                <div className="space-y-4">
                  <div className={`space-y-4 transition-all ${showFullDescription ? "" : "max-h-[9.5rem] overflow-hidden relative"}`}>
                    {renderDescription(safeString(pkg.description))}
                  </div>

                  {pkg.description && pkg.description.length > 200 && (
                    <button
                      onClick={() => setShowFullDescription(prev => !prev)}
                      className="text-sm font-medium text-blue-600 hover:underline"
                    >
                      {showFullDescription ? "Read less" : "Read more"}
                    </button>
                  )}
                </div>



                {/* AMENITIES */}
                <div className="pt-4">
                    <h3 className="text-lg font-semibold text-slate-900 mb-4">
                        What’s included
                    </h3>
              {amenities.length > 0 && (
                <div className="pt-6">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                    {amenities.map((amenity) => {
                      const Icon = AMENITY_ICON_MAP[amenity];
                      return (
                        <div key={amenity} className="flex items-center gap-3 text-sm text-slate-700">
                          {Icon ? <Icon className="w-5 h-5 text-[#3a2a00]" /> : <ShieldCheck className="w-5 h-5 text-[#3a2a00]" />}
                          <span>{safeString(amenity)}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

             </div>
            </div>
          </div>

          {/* ================= RIGHT ================= */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-white border rounded-2xl p-5 shadow-sm">
              <h3 className="text-lg font-semibold">Property highlights</h3>
              <ul className="mt-4 space-y-3 text-sm">
                <li>📍 Prime location</li>
                <li>🏨 Luxury accommodation</li>
                <li>🍽️ Meals included</li>
                <li>✈️ Flights & transfers</li>
              </ul>
            </div>
            
            {/* ================= BOOKING CARD ================= */}
            <div className="bg-white border rounded-2xl p-6 shadow-sm space-y-5">

            {/* Price */}
            <div>
                <p className="text-sm text-slate-500">Starting from</p>
                <div className="flex items-end gap-2">
                <p className="text-3xl font-bold text-slate-900">
                    ${pkg.price}
                </p>
                <span className="text-sm text-slate-500 mb-1">
                    / package
                </span>
                </div>
            </div>
           <PackageAvailabilityCalendar  pkg={pkg}
             onChange={(info) => setBookingInfo(info)} />
            {/* CTA */}
              <button
                disabled={!bookingInfo?.available}
                className={`w-full font-semibold py-3.5 rounded-xl transition-all shadow-lg hover:shadow-xl active:scale-[0.98]
                  ${bookingInfo?.available ? "bg-[#3a2a00] hover:bg-black text-white" : "bg-slate-300 text-slate-600 cursor-not-allowed"}`}
              >
                Reserve Now
              </button>


            {/* Trust / Info */}
            <div className="space-y-2 text-sm text-slate-600">
                <div className="flex items-center gap-2">
                <span>✅</span>
                <span>Free cancellation available</span>
                </div>
                <div className="flex items-center gap-2">
                <span>🔒</span>
                <span>Secure booking</span>
                </div>
                <div className="flex items-center gap-2">
                <span>💬</span>
                <span>24/7 customer support</span>
                </div>
            </div>

            {/* Urgency / Reassurance */}
            <div className="text-xs text-slate-500 border-t pt-3">
                No payment required today • Limited availability
            </div>
            </div>
            {/* ================= MAP ================= */}
            <div className="bg-white border rounded-2xl overflow-hidden shadow-sm">
              <iframe
                title="Package Location"
                src="https://www.google.com/maps?q=Dubai&output=embed"
                width="100%"
                height="260"
                loading="lazy"
                style={{ border: 0 }}
              />
            </div>
          </div>
        </div>
      </main>

        {/* ================= CUSTOM LIGHTBOX ================= */}
        {lightboxOpen && hasImages && (
        <div className="fixed inset-0 z-[99999] bg-black/70 backdrop-blur-sm flex items-center justify-center">

            {/* BACKDROP */}
            <div
            className="absolute inset-0"
            onClick={() => setLightboxOpen(false)}
            />

            {/* WRAPPER */}
            <div className="relative z-[100000] w-full h-full flex items-center justify-center px-4">

            {/* CLOSE */}
            <button
                onClick={() => setLightboxOpen(false)}
                className="absolute top-6 right-6 bg-black/60 text-white w-10 h-10 rounded-full flex items-center justify-center text-3xl hover:bg-black/80 transition"
            >
                ×
            </button>

            {/* LEFT */}
            <button
                onClick={() =>
                setLightboxIndex((prev) =>
                    prev === 0 ? imagesForLightbox.length - 1 : prev - 1
                )
                }
                className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 
                        bg-black/50 hover:bg-black/70 
                        w-10 h-10 sm:w-12 sm:h-12 
                        rounded-full flex items-center justify-center 
                        text-white text-xl sm:text-2xl 
                        z-[100001] transition"
            >
                ‹
            </button>

            {/* IMAGE */}
            <div
                className="relative max-w-5xl w-full flex items-center justify-center touch-pan-y"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <img
                src={getImageUrl(lightboxIndex)}
                onError={(e) => (e.currentTarget.src = PLACEHOLDER)}
                alt=""
                className="max-w-[95vw] max-h-[85vh] object-contain rounded-lg shadow-2xl animate-fadeIn"
                loading="eager"
                fetchpriority="high"
                />

                {/* COUNTER */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 
                                bg-black/70 text-white px-4 py-1 rounded-full text-sm">
                {lightboxIndex + 1} / {imagesForLightbox.length}
                </div>
            </div>

            {/* RIGHT */}
            <button
                onClick={() =>
                setLightboxIndex((prev) =>
                    prev === imagesForLightbox.length - 1 ? 0 : prev + 1
                )
                }
                className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 
                        bg-black/50 hover:bg-black/70 
                        w-10 h-10 sm:w-12 sm:h-12 
                        rounded-full flex items-center justify-center 
                        text-white text-xl sm:text-2xl 
                        z-[100001] transition"
            >
                ›
            </button>
            </div>
        </div>
        )}

    </>
  );
}





